export default "__VITE_ASSET__ush188gY__"